import * as cardValidator from 'card-validator'
import moment from 'moment'

export const validateCreditCard = (cardNumber) => {
    return cardValidator.number(cardNumber)
}

export const isIsraeliIdValid = (id) => {
    let strId = String(id).trim().padStart(9, '0')
    let counter = 0
    for (let i = 0; i < strId.length; i++) {
        let rawVal = Number(strId[i]) * ((i % 2) + 1)
        counter += rawVal > 9 ? rawVal - 9 : rawVal
    }
    return counter % 10 === 0
}

export const isValidDate = (str) => moment(str).isValid() //str instanceof Date && !isNaN(str)
